import ProgressLoad from "./ProgressLoad/ProgressLoad";

export default ProgressLoad
